{
  "name": "piscinapp-app",
  "version": "5.19.2",
  "author": "Piscinapp LTDA",
  "homepage": "https://piscinapp.com.br/",
  "scripts": {
    "start": "npm run live",
    "build:pro": "ionic build --no-telemetry --project pro-app",
    "build:standard": "ionic build --no-telemetry --project standard-app",
    "dev": "npm run dev:standard",
    "dev:pro": "scripts/run-android-pro-dev.sh",
    "dev:standard": "scripts/run-android-standard-dev.sh",
    "lint": "eslint \"projects/pro-app/src/**/*.ts\" \"projects/pro-app/src/**/*.html\" \"projects/standard-app/src/**/*.ts\" \"projects/standard-app/src/**/*.html\" \"projects/libs/**/*.ts\" \"projects/libs/**/*.html\"",
    "log": "scripts/log.sh -i 'Capacitor/Console|CapacitorPlugin|Capacitor'",
    "log:all": "scripts/log.sh",
    "log:console": "scripts/log.sh -i 'Capacitor/Console'",
    "log:plugin": "scripts/log.sh -i 'CapacitorPlugin'",
    "build:ios:dev:pro": "scripts/build-ios-pro-dev.sh",
    "build:ios:prod:pro": "scripts/build-ios-pro-prod.sh",
    "build:ios:dev:standard": "scripts/build-ios-standard-dev.sh",
    "build:ios:prod:standard": "scripts/build-ios-standard-prod.sh",
    "android:dev:pro": "scripts/run-android-pro-dev.sh",
    "android:dev:standard": "scripts/run-android-standard-dev.sh",
    "test:integration": "scripts/e2e/android.sh run all",
    "test:integration:android": "scripts/e2e/android.sh run all",
    "test:integration:android:standard": "scripts/e2e/android.sh run standard",
    "test:integration:android:standard:authenticated": "scripts/e2e/android.sh run standard-authenticated",
    "test:integration:android:standard:unauthenticated": "scripts/e2e/android.sh run standard-unauthenticated",
    "test:integration:android:pro": "scripts/e2e/android.sh run pro",
    "test:integration:android:pro:employee": "scripts/e2e/android.sh run pro-employee",
    "test:integration:android:pro:franchisee": "scripts/e2e/android.sh run pro-franchisee",
    "test:integration:android:pro:admin": "scripts/e2e/android.sh run pro-admin",
    "test:e2e:types": "tsc --project e2e/tsconfig.json --noEmit",
    "lint:e2e": "node --max-old-space-size=8192 node_modules/eslint/bin/eslint.js \"e2e/**/*.ts\"",
    "e2e:android:agent": "scripts/e2e/android.sh agent",
    "e2e:android:status": "scripts/e2e/android.sh status",
    "e2e:android:reset": "scripts/e2e/android.sh reset",
    "e2e:android:stop": "scripts/e2e/android.sh stop",
    "e2e:android:screenshot": "scripts/e2e/android.sh screenshot",
    "e2e:android:logs": "scripts/e2e/android.sh logs",
    "e2e:android:emulator:build": "scripts/e2e/android.sh build-emulator",
    "version:native": "scripts/update-native-versions.js",
    "live": "sh ./scripts/run-live.sh",
    "test": "cd tests && ng test",
    "test:coverage": "npm test -- --coverage",
    "test:access": "npm test -- --include=\"access/**/*.spec.ts\"",
    "test:analyses": "npm test -- --include=\"analyses/**/*.spec.ts\"",
    "test:suggestions": "npm test -- --include=\"suggestions/**/*.spec.ts\"",
    "test:visits": "npm test -- --include=\"visits/**/*.spec.ts\"",
    "test:clock-ins": "npm test -- --include=\"clock-ins/**/*.spec.ts\"",
    "test:stock": "npm test -- --include=\"stock/**/*.spec.ts\"",
    "test:synchronization": "npm test -- --include=\"synchronization/**/*.spec.ts\"",
    "test:registrations": "npm test -- --include=\"registrations/**/*.spec.ts\"",
    "test:reports": "npm test -- --include=\"reports/**/*.spec.ts\"",
    "test:watch": "npm test -- --watch",
    "test:ci": "npm test -- --configuration=ci",
    "lint:tests": "node --max-old-space-size=8192 node_modules/eslint/bin/eslint.js \"tests/**/*.ts\""
  },
  "private": true,
  "engines": {
    "node": "^26.0.0"
  },
  "dependencies": {
    "@angular/common": "^21.0.6",
    "@angular/core": "^21.0.6",
    "@angular/forms": "^21.0.6",
    "@angular/platform-browser": "^21.0.6",
    "@angular/router": "^21.0.6",
    "@awesome-cordova-plugins/splash-screen": "^6.14.0",
    "@capacitor-community/camera-preview": "^8.0.2",
    "@capacitor-community/native-market": "^8.0.0",
    "@capacitor/android": "^8.5.0",
    "@capacitor/app": "^8.1.1",
    "@capacitor/core": "^8.5.0",
    "@capacitor/filesystem": "^8.1.2",
    "@capacitor/geolocation": "^8.2.0",
    "@capacitor/ios": "^8.5.0",
    "@capacitor/preferences": "^8.0.1",
    "@capacitor/push-notifications": "^8.1.2",
    "@capacitor/share": "^8.0.1",
    "@capacitor/splash-screen": "^8.0.2",
    "@capawesome/capacitor-app-review": "^8.0.1",
    "@capawesome/capacitor-file-picker": "^8.0.3",
    "@googlemaps/js-api-loader": "^1.16.2",
    "@googlemaps/markerclusterer": "^2.5.3",
    "@ionic/angular": "^8.7.15",
    "@ionic/core": "^8.7.3",
    "@js-temporal/polyfill": "^0.5.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@tensorflow/tfjs": "^2.8.6",
    "@types/webgl2": "^0.0.12",
    "capacitor-plugin-cdv-purchase": "13.18.0",
    "core-js": "^3.46.0",
    "firebase": "^8.10.1",
    "graphql": "^15.8.0",
    "graphql-tag": "^2.12.6",
    "html2pdf.js": "^0.14.0",
    "intl-tel-input": "^26.8.1",
    "jsqr-es6": "^1.4.0-1",
    "ngx-mask": "^16.1.9",
    "qrcode": "^1.5.4",
    "rxjs": "^7.5.0",
    "stacktrace-js": "^2.0.2",
    "tslib": "^2.3.1",
    "uuid": "^7.0.3"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.1.0",
    "@angular-eslint/eslint-plugin": "^21.1.0",
    "@angular-eslint/eslint-plugin-template": "^21.1.0",
    "@angular-eslint/template-parser": "^21.1.0",
    "@angular/build": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler": "^21.0.6",
    "@angular/compiler-cli": "^21.0.6",
    "@angular/language-service": "^21.0.6",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "^8.5.0",
    "@ionic/angular-toolkit": "^12.3.0",
    "@ionic/cli": "^7.2.1",
    "@types/google.maps": "^3.58.1",
    "@types/node": "24.10.0",
    "@types/supercluster": "^7.1.3",
    "@typescript-eslint/eslint-plugin": "^8.52.0",
    "@typescript-eslint/parser": "^8.52.0",
    "@vitest/coverage-v8": "4.0.8",
    "@wdio/cli": "9.31.5",
    "@wdio/globals": "9.31.3",
    "@wdio/local-runner": "9.31.5",
    "@wdio/mocha-framework": "9.31.5",
    "@wdio/spec-reporter": "9.31.2",
    "eslint": "^9.0.0",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-prefer-arrow": "^1.2.2",
    "jsdom": "26.1.0",
    "tsx": "4.23.13",
    "typescript": "5.9.3",
    "vitest": "4.0.8"
  },
  "description": "PiscinApp",
  "cordova": {
    "platforms": [
      "android",
      "ios"
    ]
  }
}